export default class Mask {
    constructor(parent) {
        this.parent = parent;
        this.header = parent.el;
        this.mask = this.create();
    }

    create() {
        const mask = document.createElement('div');
        mask.classList.add('overlay-navigation');
        mask.classList.add('visible');
        mask.addEventListener('click', (e) => this.parent.close());
        return mask;
    }

    show() {
        const parent = this.header.parentNode;
        if (!parent.contains(this.mask)) {
            parent.insertBefore(this.mask, this.header.nextSibling);
        }
    }

    hide() {
        const parent = this.header.parentNode;
        if (parent.contains(this.mask)) {
            parent.removeChild(this.mask);
        }
    }
}
